import { render, staticRenderFns } from "./edit-blobs-dialog.vue?vue&type=template&id=f1f98c1e&scoped=true&"
import script from "./edit-blobs-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-blobs-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f98c1e",
  null
  
)

export default component.exports